import React, {
  useReducer,
  useMemo,
  createContext,
  useEffect,
  forwardRef,
  useLayoutEffect,
  memo,
} from "react";

import { addZero, getDwk } from "bodycodi/cmap/app/js/common.js";
import CalendarList from "./calendarList";
import icon_calendar_left_disable from "bodycodi/cmap/app/svg/icon_calendar_left_disable.svg";
import icon_calendar_left from "bodycodi/cmap/app/svg/icon_calendar_left.svg";
import icon_calendar_right from "bodycodi/cmap/app/svg/icon_calendar_right.svg";

type calenadarProp = {
  onClick?: Function;
  onChangeMonth: Function;
  scheduletStateList?: any;
  isAddStep: boolean;
  hasTodayBtn: boolean;
  chooseDate?: any;
  holidays: number[];
};

export type returnType = {
  year: number;
  month: number;
  date: number;
};

const initialState = {
  onClick: () => {},
  update: () => {},
  scheduletStateList: {},
  swiper: {},
  calenderDateList: [],
  currentMonthIndex: 5,
  index: 5,
  prevIndex: 5,
  holidays: [],
  activeClndrDate: {
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
  },
  chooseDate: {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    date: new Date().getDate(),
    day: getDwk(new Date().getDay()),
    toDay: true,
  },
};

export const DispatchContext = createContext<any | null>({ dispatch: () => {} });

export const StateContext = createContext<any | null>({ state: {} });

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case "UPDATE":
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

const Calendar = forwardRef((prop: calenadarProp, ref: any) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const stateValue = useMemo(() => ({ state: state }), [state]);
  const dispatchValue = useMemo(() => ({ dispatch: dispatch }), [dispatch]);
  const { calenderDateList, index, onClick, activeClndrDate } = state;
  const { isAddStep, chooseDate, hasTodayBtn } = prop;

  useLayoutEffect(() => {
    const monthList = [];
    const date = new Date();
    const month = new Date().getMonth();
    if (isAddStep) {
      for (let i = 0; i < 3; i++) {
        monthList.push(new Date(date.getFullYear(), date.getMonth() + i, 1));
      }
      setCalenderDateList(monthList);
      return;
    }
    const formatPrevMonth = new Date(date.setMonth(month - 5));
    for (let i = 0; i < 7; i++) {
      const date = new Date(formatPrevMonth.getFullYear(), formatPrevMonth.getMonth() + i, 1);
      monthList.push(date);
    }
    setCalenderDateList(monthList);
  }, []);

  useEffect(() => {
    dispatch({ type: "UPDATE", data: prop });
  }, [prop]);

  useEffect(() => {
    if (calenderDateList.length !== 0) {
      const list = [...calenderDateList];
      const active1 = calenderDateList[index];
      const date1 = new Date(active1.getFullYear(), active1.getMonth(), 1);
      const obj: any = {};
      if (currentMonth(date1)) {
        obj.year = new Date().getFullYear();
        obj.month = new Date().getMonth() + 1;
        obj.date = new Date().getDate();
        obj.day = getDwk(new Date().getDay());
        onClick(obj);
      } else {
        obj.year = active1.getFullYear();
        obj.month = active1.getMonth() + 1;
        obj.date = active1.getDate();
        obj.day = getDwk(active1.getDay());
        setTimeout(() => {
          onClick(obj);
        }, 200);
      }
      dispatch({
        type: "UPDATE",
        data: {
          activeClndrDate: { year: date1.getFullYear(), month: date1.getMonth() },
          chooseDate: obj,
        },
      });
      if (index === 1 && !isAddStep) {
        const active = calenderDateList[0];
        const previousOneMonth = [new Date(active.getFullYear(), active.getMonth() - 1, 1)];
        const previousTwoMonth = [new Date(active.getFullYear(), active.getMonth() - 2, 1)];
        setCalenderDateList(previousTwoMonth.concat(previousOneMonth, calenderDateList));
        state.swiper.prependSlide([``, ``]);
        dispatch({
          type: "UPDATE",
          data: { index: 3, currentMonthIndex: state.currentMonthIndex + 2 },
        });
      } else if (index === calenderDateList.length - 1) {
        const active = calenderDateList[calenderDateList.length - 1];
        const date = new Date(active.getFullYear(), active.getMonth() + 1, 1);
        list.push(date);
        setCalenderDateList(list);
      }
    }
  }, [index]);

  useEffect(() => {
    const currentFullYear = Number(activeClndrDate.year);
    const currentMonth = Number(activeClndrDate.month);
    const date = new Date(currentFullYear, currentMonth, 1);
    const data = { year: date.getFullYear(), month: date.getMonth() };
    prop.onChangeMonth(data);
  }, [activeClndrDate]);

  const currentMonth = (date: Date) => {
    return (
      date.getFullYear() === new Date().getFullYear() && date.getMonth() === new Date().getMonth()
    );
  };

  const setCalenderDateList = (array: Array<any>) => {
    dispatch({ type: "UPDATE", data: { calenderDateList: array } });
  };

  const clickPrev = () => {
    state.swiper.slidePrev();
  };

  const clickNext = () => {
    state.swiper.slideNext();
  };

  const handleClickToday = () => {
    if (state.swiper.activeIndex === state.currentMonthIndex) {
      const sliblingsMonths =
        ref.current?.querySelectorAll(".calendar-animation")[state.currentMonthIndex];
      const currentMonthDates = sliblingsMonths.querySelectorAll(".date-month");
      currentMonthDates.forEach(function (t: any) {
        t.classList.remove("active");
      });
      const today = sliblingsMonths.querySelector(`.d${new Date().getDate()}`);
      today?.classList.add("active");
      onClick({ date: new Date().getDate() });
    } else {
      state.swiper.slideTo(state.currentMonthIndex);
    }
  };

  return (
    <DispatchContext.Provider value={dispatchValue}>
      <StateContext.Provider value={stateValue}>
        <div className="calendar" ref={ref}>
          <div className="calendar-header">
            <div className="year-month">
              <div className="today none">오늘</div>
              <div className="year-month-box">
                <div className="left_arrow" onClick={clickPrev}>
                  <img
                    src={
                      isAddStep && new Date().getMonth() === activeClndrDate.month
                        ? icon_calendar_left_disable
                        : icon_calendar_left
                    }
                    alt=""
                  />
                </div>
                <span>
                  {activeClndrDate.year}. {addZero(activeClndrDate.month + 1)}
                </span>
                <div className="right_arrow" onClick={clickNext}>
                  <img src={icon_calendar_right} alt="" />
                </div>
              </div>
              <div className={`today ${!hasTodayBtn && "none"}`} onClick={handleClickToday}>
                오늘
              </div>
            </div>
            <div className="week">
              <div className="day">일</div>
              <div className="day">월</div>
              <div className="day">화</div>
              <div className="day">수</div>
              <div className="day">목</div>
              <div className="day">금</div>
              <div className="day">토</div>
            </div>
          </div>
          <CalendarList isAddStep={isAddStep} chooseDate={chooseDate} />
        </div>
      </StateContext.Provider>
    </DispatchContext.Provider>
  );
});
Calendar.displayName = "Calendar";

export default memo(Calendar);
